import styled from 'styled-components';
import { maxMediaQueries, minMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { grid } from '@finect/tabular-utils/grid';
import { getFont } from '@finect/tabular-utils/getFont';
import { fontSmoothing } from '@finect/tabular-utils/fontSmoothing';

export const HeroCTA = styled.div`
  max-width: ${grid(3)}px;
  margin-top: 54px;
  ${fontSmoothing};
  color: #fff;

  ${minMediaQueries.desktop`
    max-width: ${grid(4)}px;
    padding-left: ${grid(1)}px;
  `}

  ${maxMediaQueries.phone`
    margin-left: auto;
    margin-right: auto;
  `};

  a {
    border-bottom: 1px dotted transparent;
    margin-top: 9px;
    ${getFont(-1)};
    font-weight: 500;
    color: #fff;
    transition: border-color 0.15s ease;

    &:hover {
      border-bottom: 1px dotted rgb(255 255 255 / 0.25);
    }

    // &:first-of-type {
    //   position: relative;
    //   margin-right: 29px;

    //   &:after {
    //     display: inline-block;
    //     position: absolute;
    //     top: 3px;
    //     right: -14px;
    //     opacity: 0.5;
    //     width: 1px;
    //     height: 15px;
    //     content: '';
    //     background-color: rgb(255 255 255 / 0.5);
    //   }
    // }
  }
`;
